module.exports = {
    workinghours: {
        0: null,
        1: ['09:00:00', '17:00:00'],
        2: ['09:00:00', '17:00:00'],
        3: ['09:00:00', '17:00:00'],
        4: ['09:00:00', '17:00:00'],
        5: ['09:00:00', '17:00:00'],
        6: null
    },
    holidays: []
};
